import swal from "sweetalert";

/**
 * Generic helper to confirm and remove uploaded media (image or video).
 * Reused by both Create and Edit Hero Banner screens.
 *
 * @param {Object} params
 * @param {() => void} params.onConfirm - Called after user confirms removal.
 * @param {string} [params.title] - Optional custom title for the dialog.
 * @param {string} [params.text] - Optional custom text for the dialog.
 */
export const confirmAndRemoveMedia = ({
  onConfirm,
  title = "Are you sure?",
  text = "Once Removed, you will not be able to recover this file!",
} = {}) => {
  if (typeof onConfirm !== "function") return;

  swal({
    title,
    text,
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      onConfirm();
      swal("Poof! Your file has been Removed!", {
        icon: "success",
      });
    } else {
      swal("Your file is safe!");
    }
  });
};
